import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  Button,
  Grid,
  MenuItem,
  CircularProgress,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import {
  cargarNegativoDirectoAT,
  getMotivosNegativoPT
} from '../../../../../actions/traslados';
import snackbarUtils from '../../../../../utils/snackbarUtils';
import FormikSelect from '../../../../commons/formik/formikSelect';
import FormikTextField from '../../../../commons/formik/formikTextField';
import DropZone from '../../../forms/dropZone/dropZone';
import { StyledTrasladosDialog } from '../../../../styled/traslados';

const CargarNegativoDirectoDialog = ({ open, onClose, data, onRefresh }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const motivosNegativo = useSelector((state) => state.traslados.motivosNegativoPT);

  useEffect(() => {
    if (open) {
      dispatch(getMotivosNegativoPT());
    }
  }, [open, dispatch]);

  if (!data) return null;

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const imagenesDTO = [];
      if (values.imagenes && values.imagenes.length > 0) {
        for (const file of values.imagenes) {
          imagenesDTO.push({
            Base64: file.value,
            MimeType: file.mimeType,
            Nombre: file.nombre
          });
        }
      }

      dispatch(cargarNegativoDirectoAT(
        data.idTramo,
        values.horaLlegada,
        parseInt(values.idMotivo),
        values.observaciones,
        imagenesDTO
      ))
      .then(() => {
        snackbarUtils.success("Negativo directo cargado correctamente.");
        onRefresh();
        onClose();
      })
      .catch(() => {
        snackbarUtils.error("Ocurrió un error al cargar el negativo directo.");
      })
      .finally(() => {
        setLoading(false);
      });
    } catch (e) {
      snackbarUtils.error("Ocurrió un error al procesar las imágenes.");
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <StyledTrasladosDialog.Header>
        Cargar Negativo Directo - Tramo {data.nroTramoUnico}
        <StyledTrasladosDialog.CloseButton aria-label="close" onClick={onClose}>
          <CloseIcon />
        </StyledTrasladosDialog.CloseButton>
      </StyledTrasladosDialog.Header>
      <Formik
        initialValues={{
          horaLlegada: '',
          idMotivo: '',
          observaciones: '',
          imagenes: []
        }}
        validationSchema={Yup.object().shape({
          horaLlegada: Yup.string().required('Requerido').matches(/^([01]\d|2[0-3]):?([0-5]\d)$/, "Formato HH:MM válido"),
          idMotivo: Yup.string().required('Requerido'),
          observaciones: Yup.string().required('Requerido')
        })}
        onSubmit={handleSubmit}
      >
        {({ submitForm, setFieldValue, values }) => (
          <Form>
            <DialogContent sx={{ mt: 2 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <FormikTextField name="horaLlegada" label="Hora de llegada *" fullWidth placeholder="HH:MM" />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormikSelect name="idMotivo" label="Motivo *" fullWidth loading={motivosNegativo?.isFetching}>
                    <MenuItem value="">Seleccionar...</MenuItem>
                    {motivosNegativo?.data?.map((m) => (
                      <MenuItem key={m.idMotivo} value={m.idMotivo}>{m.descripcion}</MenuItem>
                    ))}
                  </FormikSelect>
                </Grid>
                <Grid item xs={12}>
                  <FormikTextField name="observaciones" label="Observaciones *" fullWidth multiline rows={3} />
                </Grid>
                <Grid item xs={12}>
                  <StyledTrasladosDialog.FieldLabel variant="body2" sx={{ mb: 1 }}>Imágenes (Max 2)</StyledTrasladosDialog.FieldLabel>
                  <DropZone
                    files={values.imagenes || []}
                    setFiles={(files) => {
                      setFieldValue("imagenes", files.slice(0, 2));
                    }}
                    configuration={{
                      oneFile: false,
                      fileMinSizeInBytes: 1,
                      maxFileSizeBytes: 5242880,
                      typifyAttachmentFile: false,
                    }}
                    accept={{
                      "image/*": [".jpeg", ".jpg", ".png"]
                    }}
                    name="imagenes"
                    error={false}
                    setError={() => {}}
                    dropzoneText="Arrastre o haga click para adjuntar imágenes (Max 2)"
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <StyledTrasladosDialog.Actions>
              <Button onClick={onClose} color="inherit" disabled={loading}>Cancelar</Button>
              <StyledTrasladosDialog.PrimaryButton onClick={submitForm} variant="contained" disabled={loading}>
                {loading ? <CircularProgress size={24} color="inherit" /> : "Cargar Negativo"}
              </StyledTrasladosDialog.PrimaryButton>
            </StyledTrasladosDialog.Actions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default CargarNegativoDirectoDialog;
